/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

'use strict';

/**
 * A directive that is used to set the isAnyFieldUpdated to true when the form value changes.
 * eg : <form name = "mo365Config" organization-unsaved-changes>
 */

angular.module('bulbApp.organizationModule')
.directive('organizationUnsavedChanges', organizationUnsavedChanges);

function organizationUnsavedChanges() {
  return {
    restrict: 'A',
    require: 'form',
    link: function(scope, element) {

      /**
       * Register event on form change.
       */
      element.on('change', function () {
        //Set the value to true when the form value changes.
        scope.organizationCtrl.isAnyFieldUpdated = true;
      });
    }
  };
}
